<ng-container *ngIf="action$ | async"></ng-container>

<div class="flex flex-row flex-wrap gap-3 mb-3">
  <button mat-raised-button i18n (click)="addBanding()" color="accent">Добавить</button>

  <button mat-raised-button i18n (click)="applyEdgeBandingToAllSides()" color="accent">Облицевать все</button>
</div>

<mat-nav-list *ngIf="data$ | async">
  <mat-list-item
    [activated]="item.isActive"
    [ngClass]="{ 'bg-sky-100': item.isActive }"
    *ngFor="let item of edgeBanding"
    (click)="toggleSelection(item)">
    <span [matTooltip]="getDescription(item)" matListItemTitle>{{ getDescription(item) }}</span>
    <button mat-icon-button matListItemMeta (click)="deleteEdgeBanding(item)">
      <mat-icon>delete</mat-icon>
    </button>
  </mat-list-item>
</mat-nav-list>
